<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="18"
    viewBox="0 0 15 18"
    fill="none"
  >
    <path
      d="M14.3673 7.98182C14.3673 12.4117 11.3023 16.5543 7.18364 17.56C3.06502 16.5543 0 12.4117 0 7.98182V3.19273L7.18364 0L14.3673 3.19273V7.98182ZM7.18364 15.9636C10.1768 15.1655 12.7709 11.6056 12.7709 8.15742V4.23036L7.18364 1.74004V15.9636Z"
      fill="#7D87E5"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "LoginEncryptedIcon",
});
</script>

<style scoped lang="scss"></style>
